var map = {
	"./alain-mikli.json": 1949,
	"./clearly.json": 5861,
	"./david-clulow-opticians.json": 2981,
	"./david-clulow.json": 3996,
	"./foreyes.json": 4646,
	"./grandoptical.json": 1571,
	"./grandvision.json": 9669,
	"./jcpenney.json": 9559,
	"./laubman-and-pank.json": 2396,
	"./lenscrafters.json": 2411,
	"./masvision.json": 3856,
	"./multiopticas.json": 7083,
	"./oakley-vault.json": 3305,
	"./oakley.json": 1652,
	"./oliver-peoples.json": 5743,
	"./opsm.json": 9710,
	"./optica2000.json": 415,
	"./pearle-vision.json": 1405,
	"./persol.json": 9634,
	"./ray-ban.json": 6763,
	"./salmoiraghi--vigan.json": 2498,
	"./solaris.json": 3822,
	"./spectacle-hut.json": 7069,
	"./sunglass-hut.json": 9963,
	"./target.json": 1536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7304;